import { render, staticRenderFns } from "./LmFormSeparatorBuilderUi.vue?vue&type=template&id=dc8b81d4&"
import script from "./LmFormSeparatorBuilderUi.vue?vue&type=script&lang=js&"
export * from "./LmFormSeparatorBuilderUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports